// Read Environment Variables and assign them to a global window variable
window.wwfconfigs = process.env;


// WEBPACK FOOTER //
// ./src/wwfconfigs.js